export enum PAGES {
  SignUp = 'SignUp',
  Home = 'Home',
  Clientlist = 'Clientlist',
  EmailOutreach = 'EmailOutreach',
  TextOutreach = 'TextOutreach',
  Programs = 'Programs',
  WaiverSignees = 'WaiverSignees',
  FacilityOperations = 'FacilityOperations',
  HowItWorks = 'HowItWorks',
  Pricing = 'Pricing',
  About = 'About',
  News = 'News',
  Facilities = 'Facilities',
  DiscardedAppointment = 'DiscardedAppointment',
  FacilityVisitor = 'FacilityVisitor',
  FacilityBookNow = 'FacilityBookNow',
  Profile = 'Profile',
  ClientProfile = 'ClientProfile',
  ExternalProgram = 'ExternalProgram',
  MyFacility = 'MyFacility',
  PublicProgram = 'PublicProgram',
  Reports = 'Reports',
  CreateClients = 'CreateClients',
}

export type Page = {
  path: string
  url: ((params?: string, params2?: string) => string) | (() => string)
  title: string
}

export const pages: Record<PAGES, Page> = {
  [PAGES.SignUp]: {
    path: '/sign-up',
    url: () => '/sign-up',
    title: 'Sign up',
  },
  [PAGES.Home]: {
    path: '/',
    url: () => '/',
    title: 'Home',
  },
  [PAGES.HowItWorks]: {
    path: '/how-it-works',
    url: () => '/how-it-works',
    title: 'How it works',
  },
  [PAGES.Pricing]: {
    path: '/pricing',
    url: () => '/pricing',
    title: 'Pricing',
  },
  [PAGES.About]: {
    path: '/about',
    url: () => '/about',
    title: 'About',
  },
  [PAGES.News]: {
    path: '/news',
    url: () => '/news',
    title: 'News',
  },
  [PAGES.Profile]: {
    path: '/profile',
    url: () => '/profile',
    title: 'Profile',
  },
  [PAGES.Facilities]: {
    path: '/locations/:locationId',
    url: locationId => `/locations/${locationId || ''}/`,
    title: 'Facilities',
  },
  [PAGES.FacilityVisitor]: {
    path: '/locations/:locationId/reservations',
    url: locationId => `/locations/${locationId || ''}/reservations`,
    title: 'Facility Visitor',
  },
  [PAGES.Reports]: {
    path: '/locations/:locationId/settings/reports',
    url: locationId => `/locations/${locationId || ''}/settings/reports`,
    title: 'Reports',
  },
  [PAGES.CreateClients]: {
    path: '/locations/:locationId/settings/create-clients',
    url: locationId => `/locations/${locationId || ''}/settings/create-clients`,
    title: 'Create Clients',
  },
  [PAGES.FacilityBookNow]: {
    path: '/locations/:locationId/reservations/booking-now',
    url: locationId =>
      `/locations/${locationId || ''}/reservations/booking-now`,
    title: 'Facility Visitor Booking',
  },
  [PAGES.ExternalProgram]: {
    path: '/locations/:locationId/programs',
    url: locationId => `/locations/${locationId || ''}/programs`,
    title: 'Programs',
  },
  [PAGES.ClientProfile]: {
    path: '/locations/:locationId/settings/clients/:clientId',
    url: (locationId, clientId) =>
      `/locations/${locationId || ''}/settings/clients/${clientId || ''}`,
    title: 'Client Profile',
  },
  [PAGES.Clientlist]: {
    path: '/locations/:locationId/settings/client-list',
    url: locationId => `/locations/${locationId || ''}/settings/client-list`,
    title: 'Client List',
  },
  [PAGES.EmailOutreach]: {
    path: '/locations/:locationId/settings/email-outreach',
    url: locationId => `/locations/${locationId || ''}/settings/email-outreach`,
    title: 'Email Outreach',
  },
  [PAGES.TextOutreach]: {
    path: '/locations/:locationId/settings/text-outreach',
    url: locationId => `/locations/${locationId || ''}/settings/text-outreach`,
    title: 'Text Outreach',
  },
  [PAGES.Programs]: {
    path: '/locations/:locationId/settings/programs',
    url: locationId => `/locations/${locationId || ''}/settings/programs`,
    title: 'Programs',
  },
  [PAGES.WaiverSignees]: {
    path: '/locations/:locationId/settings/waiver-signees',
    url: locationId => `/locations/${locationId || ''}/settings/waiver-signees`,
    title: 'Waiver Signees',
  },
  [PAGES.FacilityOperations]: {
    path: '/locations/:locationId/settings/facility-operations',
    url: locationId =>
      `/locations/${locationId || ''}/settings/facility-operations`,
    title: 'Facility Operations',
  },
  [PAGES.DiscardedAppointment]: {
    path: '/locations/:locationId/settings/discarded-appointment',
    url: locationId =>
      `/locations/${locationId || ''}/settings/discarded-appointment`,
    title: 'Discarded Appointment',
  },
  [PAGES.MyFacility]: {
    path: '/settings/facility',
    url: () => '/settings/facility',
    title: 'My Facility',
  },
  [PAGES.PublicProgram]: {
    path: '/locations/:locationId/settings/public-programs',
    url: locationId =>
      `/locations/${locationId || ''}/settings/public-programs`,
    title: 'Public Programs',
  },
}
